import { render, staticRenderFns } from "./RsaPazienteArmadiettoComponent.vue?vue&type=template&id=2bfb23f4"
import script from "./RsaPazienteArmadiettoComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteArmadiettoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports